import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextOrListCard } from '@models/condition.models';
import { CardComponent } from '@ui/pages/conditions-page/condition-sheet/sections/cards/index';
import { MarkdownPipe } from '@pipes/markdown.pipe';

@Component({
  selector: 'app-margin-panel',
  standalone: true,
  templateUrl: './margin-panel.component.html',
  styleUrl: './margin-panel.component.scss',
  imports: [CommonModule, CardComponent, MarkdownPipe],
})
export class MarginPanelComponent {
  /** Panel heading */

  /** List of strings to render */
  @Input() cards: TextOrListCard[] = [];
  @Input() headingLevel: number = 3;
}
